import { message } from "antd";

export function showSuccessMessage(data) {
    message.success(data)
}
export function showErrorMessage(data) {
    message.error(data)
}